import styled from "styled-components";

import { THEME } from "THEME";

export const TileTypeBackground = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 12px;
  z-index: 1;
  border: 2px solid rgba(234, 228, 209, 0);
  transition: border ${THEME.TRANSITION}, background-color ${THEME.TRANSITION};
`;

export const TileTypeLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  padding: 10px 20px;
  margin-bottom: 12px;
  cursor: pointer;

  input {
    position: absolute;
    z-index: 3;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    cursor: pointer;
    opacity: 0;
    
    &:checked + ${TileTypeBackground} {
      border: ${props => `2px solid ${props?.isV4 ? THEME.COLOR_DARK_GREEN : THEME.COLOR_BROWN_FOCUSED}`};
    }
  }
  ${TileTypeBackground} {
    background-color: ${props => props?.isV4 ? THEME.COLOR_OLD_GREEN : THEME.COLOR_BROWN};
  }

  @media (min-width: 960px) {
    padding: 5px 30px;
    &:last-child {
      margin-bottom: 0;
    }

    &:hover ${TileTypeBackground} {
      border: ${props => `2px solid ${props?.isV4 ? THEME.COLOR_DARK_GREEN : THEME.COLOR_BROWN_FOCUSED}`};
    }
  }

  &:active ${TileTypeBackground} {
    background-color: ${props => props?.isV4 ? THEME.COLOR_OLD_GREEN : THEME.COLOR_BROWN_FOCUSED};
    border: ${props => `2px solid ${props?.isV4 ? THEME.COLOR_DARK_GREEN : THEME.COLOR_BROWN_FOCUSED}`};
  }

  &:last-child {
    margin-bottom: 0;
  }

`;

export const TileTypeImage = styled.img`
  width: 100%;
  max-width: 80px;
  height: auto;
  display: block;
  position: relative;
  z-index: 2;
  @media (min-width: 960px) {
    max-width: 100px;
  }
`;

export const TileTypeContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 8px;
  position: relative;
  z-index: 2;
  @media (min-width: 960px) {
    margin-right: 20px;
  }
`;

export const TileTypeTitle = styled.h3`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 2px;
  color: ${THEME.COLOR_BLACK};
  @media (min-width: 960px) {
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 0;
  }
`;

export const TileTypeDescription = styled.h3`
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: ${THEME.COLOR_DARK_GRAY};
  @media (min-width: 960px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

